// extracted by mini-css-extract-plugin
module.exports = {"atm_tr_jyd4s5":"atm_tr_jyd4s5"};